import React, { useEffect, useState, useContext } from 'react';
import { ArrowRightIcon, BellIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, FileTextIcon, DollarSignIcon, PencilRulerIcon, CalendarIcon, SearchIcon, ChevronRightIcon, RefreshCwIcon, BarChart3Icon, TrendingUpIcon, UsersIcon, LayoutDashboardIcon, ZapIcon, StarIcon, ShieldIcon } from 'lucide-react';
import { FairContext } from '../contexts/FairContext';
import { FairPromotion } from '../components/FairPromotion';
export function HomePageAlternative2({
  onNavigate
}) {
  const {
    activeFair,
    setActiveFair
  } = useContext(FairContext);
  const [showPromotion, setShowPromotion] = useState(true);
  // Add an effect to log when the active fair changes
  useEffect(() => {
    if (activeFair && activeFair.hasQRCode) {
      console.log('Home page detected active fair with QR:', activeFair);
      setShowPromotion(true);
    }
  }, [activeFair]);
  const handleClosePromotion = () => {
    setShowPromotion(false);
  };
  // Mock data for alerts and pending orders
  const alerts = [{
    id: 1,
    type: 'order',
    title: 'New order received',
    description: 'Order #HX6AA6-3 received from AiscoEurope SAU',
    time: '10 minutes',
    priority: 'high'
  }, {
    id: 2,
    type: 'quote',
    title: 'Quote pending approval',
    description: 'Quote #DKEYFH-1 awaiting approval',
    time: '2 hours',
    priority: 'medium'
  }, {
    id: 3,
    type: 'design',
    title: 'Design shared',
    description: 'Daniel Fernández shared a design with you',
    time: '1 day',
    priority: 'low'
  }, {
    id: 4,
    type: 'quote',
    title: '3 new quotes created',
    description: 'New quotes have been created in the last 24 hours',
    time: '5 hours',
    priority: 'medium'
  }, {
    id: 5,
    type: 'quote',
    title: '4 quotes expiring soon',
    description: 'Quotes that will expire in the next 7 days',
    time: '1 day',
    priority: 'high'
  }];
  const pendingOrders = [{
    id: 'HX6AA6-3',
    customer: 'AiscoEurope SAU',
    product: 'Pivot Machine 8" 5/8 GALV',
    amount: '€80,108.29',
    status: 'pending',
    date: 'Jun 13, 2025'
  }, {
    id: 'DKEYFH-1',
    customer: 'HMB Irrigation',
    product: 'Reeltown 1058 ft wiper',
    amount: '$64,699.26',
    status: 'review',
    date: 'Jul 21, 2025'
  }, {
    id: 'T55NVQ',
    customer: 'HMB Irrigation',
    product: 'Pivot CP600',
    amount: '€72,350.00',
    status: 'approved',
    date: 'Jul 12, 2025'
  }];
  // Stats data
  const stats = [{
    title: 'Quotes',
    value: '12',
    change: '+3',
    icon: <FileTextIcon size={20} className="text-white" data-id="element-9189" />,
    color: 'from-blue-600 to-blue-800'
  }, {
    title: 'Designs',
    value: '8',
    change: '+2',
    icon: <PencilRulerIcon size={20} className="text-white" data-id="element-9190" />,
    color: 'from-blue-500 to-indigo-700'
  }, {
    title: 'Orders',
    value: '5',
    change: '+1',
    icon: <CheckCircleIcon size={20} className="text-white" data-id="element-9191" />,
    color: 'from-indigo-600 to-blue-900'
  }, {
    title: 'Clients',
    value: '24',
    change: '+4',
    icon: <UsersIcon size={20} className="text-white" data-id="element-9192" />,
    color: 'from-blue-700 to-indigo-800'
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9193">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-9194">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9195"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-indigo-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9196"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-9197"></div>
      </div>
      {/* Main content */}
      <div className="relative z-10 flex-1" data-id="element-9198">
        {/* Fair Promotion Banner (if there's an active fair with QR) */}
        {activeFair && activeFair.hasQRCode && showPromotion && <div className="px-6 md:px-12 pt-6" data-id="element-9199">
            <FairPromotion fair={activeFair} onClose={handleClosePromotion} data-id="element-9200" />
          </div>}
        {/* Header with welcome section */}
        <div className="px-6 md:px-12 pt-16 pb-12 max-w-7xl mx-auto" data-id="element-9201">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-9202">
            <div className="text-center md:text-left" data-id="element-9203">
              <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-indigo-200 mb-4" data-id="element-9204">
                Welcome back, Alex
              </h1>
              <p className="text-xl text-blue-100 max-w-xl" data-id="element-9205">
                Here's your simplified dashboard with alerts and pending orders
              </p>
            </div>
            <div className="flex space-x-4" data-id="element-9206">
              <button onClick={() => onNavigate('dashboard')} className="flex items-center px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-blue-800/30 rounded-xl text-white transition-all" data-id="element-9207">
                <LayoutDashboardIcon size={18} className="mr-2" data-id="element-9208" />
                Dashboard
              </button>
              <button onClick={() => onNavigate('design')} className="flex items-center px-5 py-2.5 bg-gradient-to-r from-blue-600/80 to-indigo-600/80 hover:from-blue-600 hover:to-indigo-600 border border-blue-500/30 rounded-xl text-white transition-all" data-id="element-9209">
                <PencilRulerIcon size={18} className="mr-2" data-id="element-9210" />
                New Design
              </button>
            </div>
          </div>
        </div>
        {/* Stats cards */}
        <div className="px-6 md:px-12 pb-12 max-w-7xl mx-auto" data-id="element-9211">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9212">
            {stats.map((stat, index) => <div key={index} className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:translate-y-[-2px]" data-id="element-9213">
                <div className={`bg-gradient-to-r ${stat.color} p-5`} data-id="element-9214">
                  <div className="flex justify-between items-center" data-id="element-9215">
                    <div data-id="element-9216">
                      <h3 className="text-sm font-medium text-white/80" data-id="element-9217">
                        {stat.title}
                      </h3>
                      <p className="text-3xl font-bold text-white mt-1" data-id="element-9218">
                        {stat.value}
                      </p>
                    </div>
                    <div className="bg-white/20 p-2.5 rounded-xl" data-id="element-9219">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="flex items-center text-sm text-white/80 mt-3" data-id="element-9220">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-9221" />
                    <span className="font-medium text-white" data-id="element-9222">
                      {stat.change}
                    </span>
                    <span className="ml-1" data-id="element-9223">this week</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Alerts and pending orders section */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto" data-id="element-9224">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-9225">
            {/* Alerts section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9226">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9227">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9228">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9229">
                    <BellIcon size={20} className="text-white" data-id="element-9230" />
                  </div>
                  Recent Alerts
                </h2>
                <div className="flex items-center space-x-2" data-id="element-9231">
                  <div className="px-2.5 py-1 bg-blue-500/20 text-blue-300 text-xs font-medium rounded-full flex items-center" data-id="element-9232">
                    <AlertCircleIcon size={12} className="mr-1" data-id="element-9233" />4 quotes
                    expiring soon
                  </div>
                  <div className="px-2.5 py-1 bg-indigo-500/20 text-indigo-300 text-xs font-medium rounded-full flex items-center" data-id="element-9234">
                    <FileTextIcon size={12} className="mr-1" data-id="element-9235" />3 new quotes
                  </div>
                  <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9236">
                    View all
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-9237" />
                  </button>
                </div>
              </div>
              <div data-id="element-9238">
                {alerts.map(alert => <div key={alert.id} className="p-4 hover:bg-white/5 transition-colors border-b border-blue-800/30 last:border-0" data-id="element-9239">
                    <div className="flex items-start" data-id="element-9240">
                      <div className={`mt-1 p-2 rounded-xl ${alert.priority === 'high' ? 'bg-gradient-to-br from-blue-500/20 to-indigo-500/20' : alert.priority === 'medium' ? 'bg-gradient-to-br from-blue-500/20 to-teal-500/20' : 'bg-gradient-to-br from-indigo-500/20 to-blue-500/20'}`} data-id="element-9241">
                        {alert.type === 'order' ? <FileTextIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9242" /> : alert.type === 'quote' ? <DollarSignIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9243" /> : <PencilRulerIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9244" />}
                      </div>
                      <div className="ml-4 flex-1" data-id="element-9245">
                        <h3 className="text-white font-medium" data-id="element-9246">
                          {alert.title}
                        </h3>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9247">
                          {alert.description}
                        </p>
                        <div className="flex items-center mt-2 text-xs text-blue-300" data-id="element-9248">
                          <ClockIcon size={12} className="mr-1" data-id="element-9249" />
                          {alert.time} ago
                        </div>
                      </div>
                      <button className="text-blue-400 hover:text-white p-2 rounded-lg transition-colors hover:bg-white/10" data-id="element-9250">
                        <ArrowRightIcon size={16} data-id="element-9251" />
                      </button>
                    </div>
                  </div>)}
              </div>
              <div className="p-4 bg-white/5" data-id="element-9252">
                <button className="w-full flex items-center justify-center bg-white/10 hover:bg-white/20 text-white py-2.5 rounded-xl transition-all" data-id="element-9253">
                  <RefreshCwIcon size={16} className="mr-2" data-id="element-9254" />
                  Refresh alerts
                </button>
              </div>
            </div>
            {/* Pending orders section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9255">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9256">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9257">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9258">
                    <ClockIcon size={20} className="text-white" data-id="element-9259" />
                  </div>
                  Pending Orders
                </h2>
                <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9260">
                  View all
                  <ChevronRightIcon size={16} className="ml-1" data-id="element-9261" />
                </button>
              </div>
              <div className="p-4" data-id="element-9262">
                <div className="relative" data-id="element-9263">
                  <input type="text" placeholder="Search orders..." className="w-full bg-white/10 border border-blue-800/30 rounded-xl px-10 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-9264" />
                  <SearchIcon className="absolute left-3.5 top-3 text-blue-300" size={16} data-id="element-9265" />
                </div>
              </div>
              <div className="px-4" data-id="element-9266">
                {pendingOrders.map((order, index) => <div key={order.id} className={`p-4 rounded-xl mb-3 ${order.status === 'pending' ? 'bg-white/5 border border-blue-500/20' : order.status === 'review' ? 'bg-white/5 border border-indigo-500/20' : 'bg-white/5 border border-teal-500/20'}`} data-id="element-9267">
                    <div className="flex justify-between items-start" data-id="element-9268">
                      <div data-id="element-9269">
                        <div className="flex items-center" data-id="element-9270">
                          <span className="text-white font-medium" data-id="element-9271">
                            {order.customer}
                          </span>
                          <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-9272">
                            {order.id}
                          </span>
                        </div>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9273">
                          {order.product}
                        </p>
                        <div className="mt-2 flex items-center" data-id="element-9274">
                          <span className="text-lg font-bold text-white" data-id="element-9275">
                            {order.amount}
                          </span>
                          <span className="ml-3 text-xs text-blue-300 flex items-center" data-id="element-9276">
                            <CalendarIcon size={12} className="mr-1" data-id="element-9277" />
                            {order.date}
                          </span>
                        </div>
                      </div>
                      <div data-id="element-9278">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${order.status === 'pending' ? 'bg-blue-500/20 text-blue-300' : order.status === 'review' ? 'bg-indigo-500/20 text-indigo-300' : 'bg-teal-500/20 text-teal-300'}`} data-id="element-9279">
                          {order.status === 'pending' ? <>
                              <AlertCircleIcon size={12} className="mr-1" data-id="element-9280" />
                              Pending
                            </> : order.status === 'review' ? <>
                              <FileTextIcon size={12} className="mr-1" data-id="element-9281" />
                              In review
                            </> : <>
                              <CheckCircleIcon size={12} className="mr-1" data-id="element-9282" />
                              Approved
                            </>}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 flex justify-end" data-id="element-9283">
                      <button className="text-blue-300 hover:text-white transition-colors text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg flex items-center" data-id="element-9284">
                        View details
                        <ArrowRightIcon size={14} className="ml-1" data-id="element-9285" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        {/* Quick actions section */}
        <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto" data-id="element-9286">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-9287">
            <ZapIcon size={24} className="mr-2 text-blue-400" data-id="element-9288" />
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-9289">
            <button onClick={() => onNavigate('quotes')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9290">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9291">
                <DollarSignIcon size={24} className="text-white" data-id="element-9292" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9293">
                Create Quote
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9294">
                Generate a new quote for a customer
              </p>
            </button>
            <button onClick={() => onNavigate('design')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9295">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9296">
                <PencilRulerIcon size={24} className="text-white" data-id="element-9297" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9298">
                Design System
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9299">
                Create a new irrigation system design
              </p>
            </button>
            <button onClick={() => onNavigate('order')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9300">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9301">
                <FileTextIcon size={24} className="text-white" data-id="element-9302" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9303">
                View Orders
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9304">
                Check status of current orders
              </p>
            </button>
            <button onClick={() => onNavigate('business-intelligence')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9305">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9306">
                <BarChart3Icon size={24} className="text-white" data-id="element-9307" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9308">Analytics</h3>
              <p className="text-blue-200 text-sm" data-id="element-9309">
                View business intelligence reports
              </p>
            </button>
          </div>
        </div>
        {/* Quote Score Overview */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto mb-12" data-id="element-9310">
          <div className="flex justify-between items-center mb-6" data-id="element-9311">
            <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-9312">
              <StarIcon size={24} className="mr-2 text-blue-400" data-id="element-9313" />
              Quote Score Overview
            </h2>
            <button onClick={() => onNavigate('quotes')} className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9314">
              View all quotes
              <ChevronRightIcon size={16} className="ml-1" data-id="element-9315" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9316">
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9317">
              <div className="flex justify-between items-start" data-id="element-9318">
                <div data-id="element-9319">
                  <h3 className="text-white text-lg font-medium" data-id="element-9320">High Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9321">
                    Almost ready to close
                  </p>
                </div>
                <div className="bg-blue-500/30 p-2 rounded-lg" data-id="element-9322">
                  <StarIcon size={20} className="text-blue-300" data-id="element-9323" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9324">
                <div className="text-3xl font-bold text-white" data-id="element-9325">3</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9326">
                  quotes with score 80+
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9327">
              <div className="flex justify-between items-start" data-id="element-9328">
                <div data-id="element-9329">
                  <h3 className="text-white text-lg font-medium" data-id="element-9330">
                    Medium Score
                  </h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9331">Under evaluation</p>
                </div>
                <div className="bg-indigo-500/30 p-2 rounded-lg" data-id="element-9332">
                  <StarIcon size={20} className="text-indigo-300" data-id="element-9333" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9334">
                <div className="text-3xl font-bold text-white" data-id="element-9335">4</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9336">
                  quotes with score 50-79
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9337">
              <div className="flex justify-between items-start" data-id="element-9338">
                <div data-id="element-9339">
                  <h3 className="text-white text-lg font-medium" data-id="element-9340">Low Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9341">
                    Weak or uncertain
                  </p>
                </div>
                <div className="bg-teal-500/30 p-2 rounded-lg" data-id="element-9342">
                  <StarIcon size={20} className="text-teal-300" data-id="element-9343" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9344">
                <div className="text-3xl font-bold text-white" data-id="element-9345">1</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9346">
                  quotes with score below 50
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="mt-auto relative z-10 border-t border-blue-800/30 py-6 text-center text-blue-300 text-sm" data-id="element-9347">
        <p data-id="element-9348">© 2025 Aisco Irrigation Systems. All rights reserved.</p>
      </footer>
    </div>;
}